import { getPurposeMeta, sumPotAccumulated } from '../../lib/potPurposeUtils';
import { formatEUR } from '../../utils/money';
import { PotVaultRow } from './PotVaultRow';

/**
 * @param {{ purpose: import('../../lib/potPurposeUtils').PotPurpose, pots: object[] }} props
 */
export function PotPurposeGroup({ purpose, pots }) {
  if (!pots.length) return null;

  const meta = getPurposeMeta(purpose);
  const Icon = meta.icon;
  const total = sumPotAccumulated(pots);

  return (
    <section className="flex flex-col gap-2.5">
      <header className="flex items-center gap-2.5 px-1 pt-4 pb-1">
        <span
          className={`flex h-[1.875rem] w-[1.875rem] items-center justify-center rounded-[0.5625rem] ${meta.iconBg}`}
        >
          <Icon className={`h-4 w-4 ${meta.iconColor}`} aria-hidden />
        </span>
        <h2 className="font-display text-[0.9rem] font-bold text-foreground">
          {meta.label}
        </h2>
        <span className="ml-auto font-display text-[0.8125rem] font-bold tabular-nums text-muted-foreground">
          {formatEUR(total)}
        </span>
      </header>
      <ul className="flex flex-col gap-2.5">
        {pots.map((pot) => (
          <PotVaultRow key={pot.id} pot={pot} purpose={purpose} />
        ))}
      </ul>
    </section>
  );
}
